import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-filter-select',
  templateUrl: './filter-select.component.html',
  styleUrls: ['./filter-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: FilterSelectComponent
    }
  ]
})
export class FilterSelectComponent implements OnChanges, ControlValueAccessor {
  _value = '';
  option = new FormControl('');
  touched = false;

  @Input() disabled = false;
  @Input() placeholder = '';
  @Input() options: string[] = [];
  @Input() label: string;
  @Input() canSelectAll = false;

  @Input()
  set value(value: string) {
    this._value = value;
  }

  @Output() valueChange = new EventEmitter<string>();

  @ContentChild('optionTemplate', { static: false })
  optionTemplateRef: TemplateRef<unknown>;

  @ContentChild('selectTemplate', { static: false })
  selectTemplateRef: TemplateRef<unknown>;

  // Control Value Accessor callbacks
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (_value: string): void => {};
  onTouched = (): void => {};

  selectionChange(event: MatSelectChange): void {
    const eventValue = event.value as string;
    const cleanValue = eventValue === 'All' ? '' : eventValue;
    this.value = cleanValue;
    this.onChange(cleanValue);
    this.markAsTouched();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentOptions = changes.options && (changes.options.currentValue as string[]);
    if (currentOptions && currentOptions.length === 1) {
      this.value = currentOptions[0];
    }
  }

  writeValue(value: string): void {
    if (value) {
      this.value = this.option && this.options.length === 1 ? this.options[0] : value;
    } else {
      this.value = value;
    }
  }

  markAsTouched(): void {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  registerOnChange(onChange: (value: string) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
